import { props } from '@ngrx/store';
import { createActionGroup, emptyProps } from '@ngrx/store';
import { Video, VideoError } from '../models';

export const videosActions = createActionGroup({
    source: 'Videos',
    events: {
        'Get Video': props<{ id: string }>(),
        'Get Video Success': props<{ video: Video }>(),
        'Get Video Error': props<{ video: VideoError }>(),
        'Set Loading': props<{ id: string }>(),
        Clear: emptyProps(),
    },
});
